import type { ProductViewEvent, AddToCartEvent, CheckoutStartedEvent, SelectPickupAddressEvent, OrderPlacedEvent, ProceedToCheckoutEvent } from "../types";
const isEventTrackingEnabled = process.env.REACT_APP_EVENT_TRACKING === "enabled";

export const selectCityEvent = (city_name: string, pincode: number) => {
  if (!isEventTrackingEnabled) {
    return;
  }
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'select_city',
    city_name,
    pincode
  });
}



export const searchProductEvent = (title: string) => {
  if (!isEventTrackingEnabled) {
    return;
  }
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'product_search',
    keyword: title
  });
}

export const categoryViewEvent = (category_name: string) => {
  if (!isEventTrackingEnabled) {
    return;
  }
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'category_viewed',
    category_name
  });
}


export const productViewEvent = (productViewEvent: ProductViewEvent) => {
  if (!isEventTrackingEnabled) {
    return;
  }

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'product_view',
    prid: productViewEvent.prid,
    prqt: productViewEvent.prqt || 1,
    product_name: productViewEvent.product_name,
    category: productViewEvent.category,
    brand: productViewEvent.brand,
    page_url: productViewEvent.page_url,
    product_img: productViewEvent.product_img
  });
};


export const addToCartEvent = (addToCartEvent: AddToCartEvent) => {
  if (!isEventTrackingEnabled) {
    return;
  }

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'add_to_cart',
    prid: addToCartEvent.prid,
    prqt: addToCartEvent.prqt || 1,
    product_name: addToCartEvent.product_name,
    category: addToCartEvent.category,
    brand: addToCartEvent.brand,
    selling_price: addToCartEvent.selling_price,
    product_url: addToCartEvent.product_url,
    product_img: addToCartEvent.product_img
  });
};



export const checkoutStartedEvent = (checkoutStartedEvent: CheckoutStartedEvent) => {
  if (!isEventTrackingEnabled) {
    return;
  }
  window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'checkout_started',
      items:checkoutStartedEvent.items 
    });
};

export const selectPickupAddressEvent = (selectPickupAddressEvent: SelectPickupAddressEvent) => {
  if (!isEventTrackingEnabled) {
    return;
  }

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'select_pickup_address',
    name: selectPickupAddressEvent.name,
    email: selectPickupAddressEvent.email,
    address: selectPickupAddressEvent.address,
    state: selectPickupAddressEvent.state,
    city: selectPickupAddressEvent.city,
    pincode: selectPickupAddressEvent.pincode
  });
};


export const pickupScheduledEvent = (pickup_date: Date) => {
  if (!isEventTrackingEnabled) {
    return;
  }

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'pickup_schedule',
    pickup_date
  });
};



export const proceedToCheckoutEvent = (
  proceedToCheckoutEvent: ProceedToCheckoutEvent
) => {
  if (!isEventTrackingEnabled) {
    return;
  }

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'proceed_to_checkout',
    items: proceedToCheckoutEvent.items.map(item=> ({
      prid: item.prid,
      prqt: item.prqt || 1,
      product_name: item.product_name,
      category: item.category,
      brand: item.brand,
      page_url: item.page_url,
      amount: item.amount
    }))
  });
};


export const orderPlacedEvent = (orderPlacedEvent: OrderPlacedEvent) => {
  if (!isEventTrackingEnabled) {
    return;
  }

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'order_placed',
    order_id: orderPlacedEvent.order_id,
    total_prqt: orderPlacedEvent.total_prqt,
    selling_amount: orderPlacedEvent.selling_amount,
    discount_amt: orderPlacedEvent.discount_amt,
    amount: orderPlacedEvent.amount,
    user_referral_code: orderPlacedEvent.user_referral_code,
    items: orderPlacedEvent.items.map(item => ({
      prid: item.prid,
      prqt: item.prqt || 1,
      product_name: item.product_name,
      page_url: item.page_url,
      selling_price: item.selling_price
    }))
  });
};
